import React, { Fragment, useState } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Box } from '@mui/material';
import { Typography, Checkbox, Button, Avatar, colors } from '@leapeasy/ui-kit';

import { CustomInputWrapper } from 'components/CustomWrapper';
import AlertDialog from 'components/AlertDialog';
import { submitFormAction } from 'redux/actions/getFormActions';

const Form7 = (props) => {
  const { actions, formData, handleNext, handleBack, handleStep } = props;
  const [open, setOpen] = useState(false);
  const [termCheck, setTermCheck] = useState(false);

  const buildingName = formData.propertyArray.filter(
    (item) => item.Id === formData.data.property,
  )[0].Name;

  const handleOk = () => {
    actions.submitFormAction(formData.data);
    setOpen(false);
    handleNext();
  };

  const handleSubmit = () => {
    setOpen(true);
  };

  const cardStyle = {
    padding: '12px',
    background: 'rgba(249, 248, 249, 0.8)',
    border: '1px solid #F8F4F9',
    borderRadius: '12px',
    gap: '12px',
    display: 'flex',
    flexDirection: 'column',
  };
  const contentStyle = {
    padding: '24px',
    border: '1px solid #F8F4F9',
    borderRadius: '12px',
    gap: '10px',
    background: 'white',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flexWrap: 'wrap',
  };
  const itemStyle = {
    width: '50%',
    flexGrow: 0,
    flexShrink: 0,
    borderRight: '1px solid #E8D6EB',
    boxSizing: 'border-box',
    paddingRight: '12px',
  };

  return (
    <Fragment>
      <Box display="flex" flexDirection="column" gap="20px">
        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="1" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Personal Information
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(2)}
            />
          </Box>

          <Box sx={contentStyle}>
            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  First Name
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.fname}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Last Name
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.lname}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Contact Email
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{
                    color: colors.purple[900],
                    marginTop: '8px',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  {formData.data.email}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Contact Phone Number
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{
                    color: colors.purple[900],
                    marginTop: '8px',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  {formData.data.phone}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Date Of Birth
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.birthDate}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Full-Time Student?
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.isStudent ? 'Yes' : 'No'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="2" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              About Your New Home
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(3)}
            />
          </Box>

          <Box sx={contentStyle}>
            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  State
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.state}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Building
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {buildingName}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="2" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Lease Detail
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(4)}
            />
          </Box>

          <Box sx={contentStyle}>
            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Total Monthly Rent
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  <b>$</b>
                  {formData.data.totalMthRent}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Lease Term
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.leasePeriod} month{formData.data.leasePeriod > 1 ? 's' : ''}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Move In Date
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.moveInDate}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Other Leaseholders?
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.leaseMates === 'Yes' ? 'Yes' : 'No'}
                </Typography>
              </Box>
            </Box>

            {formData.data.leaseMates === 'Yes' && (
              <>
                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Your Rent Portion
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      <b>$</b>
                      {formData.data.portionMthRent}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Number of Leaseholders
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.roommateCount + 1}
                    </Typography>
                  </Box>
                </Box>

                {new Array(parseInt(formData.data.roommateCount)).fill(0).map((item, index) => (
                  <Box key={index} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Tenant {index + 2}
                    </Typography>

                    <Box display="flex">
                      <Box sx={itemStyle}>
                        <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                          First Name
                        </Typography>
                        <Typography
                          variant="cta-xs"
                          style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                        >
                          {formData.data.roommateData[`${index + 1}_fname`]}
                        </Typography>
                      </Box>

                      <Box sx={{ paddingLeft: '12px' }}>
                        <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                          Last Name
                        </Typography>
                        <Typography
                          variant="cta-xs"
                          style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                        >
                          {formData.data.roommateData[`${index + 1}_lname`]}
                        </Typography>
                      </Box>
                    </Box>

                    <Box display="flex">
                      <Box sx={itemStyle}>
                        <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                          Contact Email
                        </Typography>
                        <Typography
                          variant="cta-xs"
                          style={{
                            color: colors.purple[900],
                            marginTop: '8px',
                            fontWeight: '500',
                            wordWrap: 'break-word',
                          }}
                        >
                          {formData.data.roommateData[`${index + 1}_email`]}
                        </Typography>
                      </Box>

                      <Box sx={{ paddingLeft: '12px' }}>
                        <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                          Phone Number
                        </Typography>
                        <Typography
                          variant="cta-xs"
                          style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                        >
                          {formData.data.roommateData[`${index + 1}_phone`]}
                        </Typography>
                      </Box>
                    </Box>

                    <Box>
                      <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                        {`Tenant ${index + 2} Rent Portion`}
                      </Typography>
                      <Typography
                        variant="cta-xs"
                        style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                      >
                        {formData.data.roommateData[`${index + 1}_portionfee`]}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </>
            )}
          </Box>
        </Box>

        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="2" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Lease Detail 2
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(5)}
            />
          </Box>

          <Box sx={contentStyle}>
            <Box>
              <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                U.S. Citizen or Permanent Resident?
              </Typography>
              <Typography
                variant="cta-xs"
                style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
              >
                {formData.data.isCitizen ? 'Yes' : 'No'}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="2" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Your Current Address
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(6)}
            />
          </Box>
          <Box sx={contentStyle}>
            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Street
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentStreet}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Unit (Optional)
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentUnit}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  City
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentCity}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  State/Province
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentState}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  PostalCode
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentPostalCode}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Country
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentCountry}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="2" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Identity Information
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(7)}
            />
          </Box>

          <Box sx={contentStyle}>
            {(!formData.data.isStudent && (
              <>
                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Highest Education Achieved
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.education}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Evicted Record
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.eviction === false ? 'No' : 'Yes'}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Employed Status
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.employment}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Available Cash
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      <b>$</b>
                      {formData.data.cash}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex">
                  {((formData.data.employment === 'Employed' ||
                    formData.data.employment === 'Self-Employed' ||
                    formData.data.employment === 'Retired') && (
                    <>
                      <Box sx={itemStyle}>
                        <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                          Employment Start Date
                        </Typography>
                        <Typography
                          variant="cta-xs"
                          style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                        >
                          {formData.data.employmentStartDate}
                        </Typography>
                      </Box>

                      <Box sx={{ paddingLeft: '12px' }}>
                        <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                          Annual Income
                        </Typography>
                        <Typography
                          variant="cta-xs"
                          style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                        >
                          <b>$</b>
                          {formData.data.annualIncome}
                        </Typography>
                      </Box>
                    </>
                  )) || (
                    <Box>
                      <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                        Annual Income
                      </Typography>
                      <Typography
                        variant="cta-xs"
                        style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                      >
                        <b>$</b>
                        {formData.data.annualIncome}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </>
            )) || (
              <>
                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Year of School during Lease
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.schoolyear}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Highest Education Achieved
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.education}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Evicted Record
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.eviction === false ? 'No' : 'Yes'}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      GPA
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.gpa}
                    </Typography>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Box>

      <Box display="flex" gap="12px" alignItems="center" mt={2}>
        <Checkbox value={termCheck || false} onChange={(val) => setTermCheck(val)} />

        <Typography variant="small" style={{ color: colors.purple[900] }}>
          Agree with&nbsp;
          <a
            href="https://www.leapeasy.com/leap-lease-program-terms-conditions/"
            target="_blank"
            color="primary"
            style={{ color: colors.purple[700] }}
          >
            Terms & Conditions
          </a>
        </Typography>
      </Box>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 4, gap: '16px' }}
      >
        <Button size="medium" variant="secondary" onClick={handleBack} style={{ flexShrink: 2 }}>
          Back
        </Button>

        <Button
          size="medium"
          onClick={() => handleSubmit()}
          disabled={!termCheck}
          style={{ flexShrink: 1 }}
        >
          Next
        </Button>
      </Box>

      <AlertDialog
        open={open}
        data={formData}
        handleClose={() => setOpen(false)}
        handleOk={handleOk}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    formData: state.formData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        submitFormAction,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form7);
